{
  "attachAria": "Adjuntar archivo",
  "emptyHint": "Describe el problema: soporte te responderá aquí",
  "emptyTitle": "Aún no hay mensajes",
  "fileOpenAria": "Abrir archivo adjunto",
  "logAria": "Conversación de la solicitud",
  "newMessages": "Mensajes nuevos",
  "placeholder": "Escribe un mensaje…",
  "placeholderDisabled": "Los mensajes no están disponibles temporalmente",
  "previewAria": "Ver archivo adjunto",
  "previewCloseAria": "Cerrar vista previa",
  "removeAttachmentAria": "Eliminar archivo",
  "retry": "Reintentar",
  "screenshotAria": "Hacer una captura de pantalla",
  "seen": "Visto",
  "sendAria": "Enviar mensaje",
  "sendFailed": "No se ha podido enviar el mensaje",
  "sending": "Enviando…",
  "student": "Estudiante",
  "supportName": "Soporte de Skyeng",
  "today": "Hoy",
  "yesterday": "Ayer",
  "you": "Tú"
}
